<template>
  <nav
    class="navbar is-fixed-top"
    role="navigation"
    id="top-navbar"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <img src="~@/assets/topbar_decoration.png" style="height: 100%;" />
      <a class="navbar-item" @click="goToMainDomain()">
        <img :src="require(`@/assets/logos/${domain}.png`)" />
      </a>
    </div>
    <div class="is-hidden-mobile" v-if="isLogged && rol == 'client'" style="display: flex;">
      <a
        v-for="topBarLink in topBarLinks"
        :key="topBarLink.routeName"
        @click="$router.push({ name: topBarLink.routeName })"
        class="navbar-item has-divider is-desktop-icon-only"
        :title="topBarLink.label"
      >
        <text-icon-tile :title="topBarLink.label" :icon="topBarLink.icon" />
      </a>
    </div>
    <div class="navbar-brand is-right">
      <div class="navbar-item navbar-item-menu-toggle is-hidden-desktop">
        <a @click.prevent="menuNavBarToggle">
          <b-icon :icon="menuNavBarToggleIcon" custom-size="default"></b-icon>
        </a>
      </div>
    </div>
    <div
      id="onBoardTopNavbar"
      class="navbar-menu"
      :class="{ 'is-active': isMenuNavBarActive }"
    >
      <div class="navbar-end">
        <nav-bar-menu v-if="isLogged" class="has-divider">
          <div class="is-user-name">
            <span>{{ userEmail }}</span>
            <b-icon icon="chevron-down" custom-size="default"></b-icon>
          </div>

          <div slot="dropdown" class="navbar-dropdown">
            <a
              v-if="rol != 'client'"
              class="navbar-item"
              @click.prevent="$router.push({ name: 'admin.dashboard' })"
            >
              <b-icon icon="chart-line-variant" custom-size="default"></b-icon>
              <span>{{ $t('Dashboard') }}</span>
            </a>
            <a
              v-else
              class="navbar-item"
              @click.prevent="
                $router.push({
                  name: 'onBoard.neofintech.myNeofintechRequests'
                })
              "
            >
              <b-icon icon="arrow-up" custom-size="default"></b-icon>
              <span>{{ $t('Solicitudes') }}</span>
            </a>
            <a
              v-if="rol == 'client'"
              class="navbar-item"
              @click.prevent="
                $router.push({
                  name: 'onBoard.neofintech.myNeofintechNotifications'
                })
              "
            >
              <b-icon icon="bell" custom-size="default"></b-icon>
              <span>{{ $t('Notificaciones') }}</span>
            </a>
            <a
              v-if="rol == 'client'"
              class="navbar-item"
              @click.prevent="
                $router.push({
                  name: 'onBoard.neofintech.myNeofintechProducts'
                })
              "
            >
              <b-icon icon="view-grid" custom-size="default"></b-icon>
              <span>{{ $t('Productos') }}</span>
            </a>
            <a
              v-if="rol == 'client'"
              class="navbar-item"
              @click.prevent="
                $router.push({
                  name: 'onBoard.neofintech.myNeofintechEcobankaTV'
                })
              "
            >
              <b-icon icon="television" custom-size="default"></b-icon>
              <span>{{ $t('Ecobanka TV') }}</span>
            </a>
            <a class="navbar-item" @click.prevent="goToProfile">
              <b-icon icon="user" pack="fas" custom-size="default"></b-icon>
              <span>{{ $t('Perfil') }}</span>
            </a>
            <hr class="navbar-divider" />
            <a class="navbar-item" @click.prevent="logout">
              <b-icon icon="logout" custom-size="default"></b-icon>
              <span>{{ $t('Cerrar sesión') }}</span>
            </a>
          </div>
        </nav-bar-menu>
        <nav-bar-menu v-else class="has-divider">
          <a
            class="navbar-item"
            @click.prevent="$router.push({ name: 'sign-in' })"
          >
            <b-icon icon="account" custom-size="default"></b-icon>
            <span>{{ $t('Acceder') }}</span>
          </a>
        </nav-bar-menu>
        <div class="navbar-item">
          <language-selector />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import LanguageSelector from '@/components/common/settings/LanguageSelector.vue'
import NavBarMenu from '@/components/theme/NavBarMenu'
import TextIconTile from '@/components/admin/dasboard/TextIconTile'
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { mapState, mapGetters } from 'vuex'
export default {
  components: { LanguageSelector, NavBarMenu, TextIconTile },
  data() {
    return {
      isMenuNavBarActive: false,
      topBarLinks: [
        {
          routeName: 'onBoard.neofintech.Dashboard',
          label: this.$t('Inicio'),
          icon: 'home'
        },
        {
          routeName: 'onBoard.neofintech.myNeofintechRequests',
          label: this.$t('Solicitudes'),
          icon: 'arrow-up'
        },
        {
          routeName: 'onBoard.neofintech.myNeofintechNotifications',
          label: this.$t('Notificaciones'),
          icon: 'bell'
        },
        {
          routeName: 'onBoard.neofintech.myNeofintechProducts',
          label: this.$t('Productos'),
          icon: 'view-grid'
        },
        {
          routeName: 'onBoard.neofintech.myNeofintechEcobankaTV',
          label: this.$t('Ecobanka TV'),
          icon: 'television'
        }
      ]
    }
  },
  computed: {
    ...mapState('user', ['userName', 'rol', 'userEmail']),
    ...mapGetters('user', ['isLogged']),
    domain() {
      return this.$store.state.domain
    },
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? 'close' : 'dots-vertical'
    },
    isNeofintech() {
      return this.$route.name.startsWith('onBoard.neofintech')
    },
    isLicitador() {
      return this.$route.name.startsWith('onBoard.licitador')
    }
  },
  methods: {
    async logout() {
      let self = this
      await Auth.signOut().then(function() {
        AmplifyEventBus.$emit('authState', 'signedOut')
        self.$store.commit('user/UNSET_USER')
      })
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive
    },
    goToProfile() {
      if (this.rol == 'client') {
        this.$router.push({ name: 'onBoard.neofintech.profile' })
      } else {
        this.$router.push({ name: 'admin.profile' })
      }
    },
    goNeofintech() {
      if (this.$router)
        this.$router.push({ name: 'onBoard.neofintech.phase1.1' })
    },
    goLicitador() {
      if (this.$router)
        this.$router.push({ name: 'onBoard.licitador.phase1.1' })
    },
    goToLogin() {
      this.$router.push({ name: 'sign-in' })
    },
    goToMainDomain() {
      window.location.href = `https://${this.$store.state.domain}.com`
    }
  }
}
</script>

<style>
.navbar-item img {
  max-height: 40px;
  height: 100%;
  width: auto;
}
/*
#top-navbar {
  background-image: url('~@/assets/topbar_decoration.png');
  background-repeat: no-repeat;
  background-size: 60px;
  background-attachment: fixed;
  background-position: 0 0;
}*/
</style>
